// Module
var code = "<div class=\"iia-list-item iia-id-{{location-id}}\"> <div class=\"iia-groupby-header-container\"> <div class=\"iia-groupby-header iia-location\"> {{header-text-title}} </div> <div class=\"iia-address-distance\">{{distance}}</div> <div class=\"iia-note\">{{note}}</div> </div> <div> {{options}} </div> </div>";
// Exports
module.exports = code;